import * as React from 'react';

import { Accordion } from '../components/Accordion';
import { Image } from '../components/Image';
import { WarningBlock } from 'src/components';
import archive from '../screenshots/Managing/archive.jpg';
import download from '../screenshots/Managing/download.jpg';
import duplicate1 from '../screenshots/Managing/duplicate1.jpg';
import duplicate2 from '../screenshots/Managing/duplicate2.jpg';
import addvalues1 from '../screenshots/Managing/addvalues1.jpg';
import addvalues2 from '../screenshots/Managing/addvalues2.jpg';
import remove1 from '../screenshots/Managing/1.jpg';
import remove2 from '../screenshots/Managing/2.jpg';
import remove3 from '../screenshots/Managing/3.jpg';
import remove4 from '../screenshots/Managing/4.jpg';
import remove5 from '../screenshots/Managing/5.jpg';
import remove6 from '../screenshots/Managing/6.jpg';
import remove7 from '../screenshots/Managing/7.jpg';

const sections = [
  {
    question: 'How can I search and filter trackinglinks?',
    answer: (
      <>
        <p>
          All trackinglinks that have been created in the tool are displayed on
          the „Existing Links“ page. Here, you can search or filter them, for
          example by date, marketing channel or trackingcode:
        </p>
        <Image src={archive} />
      </>
    ),
  },
  {
    question: 'How can I download trackinglinks?',
    answer: (
      <>
        <p>
          Trackinglinks can be downloaded on the „Existing Links“ page by
          hovering the „Export all“ button. Currently chosen filters will be
          applied to the output. You can select between a CSV and Excel file:
        </p>
        <Image src={download} />
      </>
    ),
  },
  {
    question: 'How can I duplicate trackinglinks?',
    answer: (
      <>
        <p>
          If you duplicate a trackinglink, all values selected for the original
          link will be filled out already in your new trackinglink.
        </p>
        <p>
          You can duplicate trackinglinks by clicking on the „Duplicate“ button
          on the „Created Link“ page immediately after you have created a new
          trackinglink:
        </p>
        <Image src={duplicate2} />
        <p>or on the „Existing Links“ page after a link is expanded:</p>
        <Image src={duplicate1} />
      </>
    ),
  },
  {
    question: 'How can I add new values to the Link Manager interface?',
    answer: (
      <>
        <p>
          You can add new values either in the „Create New Link“ interface, by
          using the „Add“ button or free text fields:
        </p>
        <Image src={addvalues1} />
        <p>
          or by creating new values in the admin interface (if you have admin
          privileges):
        </p>
        <Image src={addvalues2} />
      </>
    ),
  },
  {
    question:
      'How can I remove trackinglinks from the active Link Manager interface?',
    answer: (
      <>
        <WarningBlock left={true}>
          <p>
            The functionality described here only applies to removing
            trackinglinks from the tool interface, it does not change anything
            about the functionality of the trackinglink itself! If a
            trackinglink or shortlink is archived by a user, it will still work
            in the ad or content that it has been placed in.
          </p>
        </WarningBlock>

        <h4>Archiving trackinglinks</h4>
        <p>
          When you look at the trackinglinks{' '}
          <strong>that you have created yourself</strong> on the „Existing
          Links“ page, you will see an „archive“ button in the upper right hand
          corner of each link:
        </p>
        <Image src={remove1} />
        <p>
          When you click on this icon, the trackinglink will be put on the
          archive page and removed from the current view.
        </p>
        <p>
          If you want to look at the trackinglink in the Link Archive, just
          click on „Archived Links“ under the date range filter and click on the
          „Filter“ button. Now, only archived trackinglinks are displayed:
        </p>
        <Image src={remove2} />
        <p>
          If you click on „Reset“, only the active trackinglinks are again
          displayed:
        </p>
        <Image src={remove3} />

        <h4>Restoring trackinglinks</h4>
        <p>
          If you need to restore an archived trackinglink again so that it is
          displayed on the active „Existing Links“ page, you can click on the
          „Restore“ button in the upper right hand corner in the „Archived
          Links“ view. Once this button has been clicked, the trackinglink will
          automatically appear again on the „Existing Link“ page:
        </p>
        <Image src={remove4} />
      </>
    ),
  },
  {
    question: 'How can I remove values from the Link Manager interface?',
    answer: (
      <>
        <h4>Archiving Parameters and Items</h4>
        <p>
          If you need to remove values from the Link Manager interface, you can
          do so in the Admin area.
        </p>
        <p>
          Go to the Parameter or Item that you want to remove from the
          interface, and click on the „Edit“ button on the right hand side. In
          the „Edit“ view, you will then see an „Archive“ button in the bottom
          left:
        </p>
        <Image src={remove5} />
        <WarningBlock left={true}>
          <p>
            If you archive Parameters or Items, they will be removed from the
            „Create Link“ interface and can no longer be used by any user to
            create trackinglinks! Please be aware of this when archiving values.
          </p>
        </WarningBlock>
        <p>
          If you want to look at all archived parameters or items, click on the
          „Archived“ button next to the Search bar. Now, only archived
          Parameters or Items will be displayed. If you remove the check mark,
          again only active parameters or Items will be displayed.
        </p>
        <Image src={remove6} />
        <h4>Restoring Parameters and Items</h4>
        <p>
          If you need to restore an archived Parameter or Item back again to the
          active view, first go into the „Archived“ view and select the
          Parameter or Item you want to restore. Click on the „Edit“ button. You
          will see a „Restore“ button in the bottom left.{' '}
        </p>
        <p>
          Once the „Restore“ button has been clicked, the parameter or Item will
          appear again in the active interface and will be displayed to all
          users in the „Create Link“ page:
        </p>
        <Image src={remove7} />
      </>
    ),
  },
];

export const Managing = ({ index }: { index: number }) => (
  <div>
    <h2 className="mt-12 mb-6">{index}. Managing tracking links</h2>
    {sections.map(({ question, answer }, subindex) => (
      <Accordion
        title={`${index}.${subindex + 1}. ${question}`}
        content={answer}
        key={subindex}
      />
    ))}
  </div>
);



// WEBPACK FOOTER //
// ./src/views/Tutorial/sections/Managing.tsx